module.exports = __webpack_public_path__ + "svg/chalice.d559c1.svg";